import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { FC } from "react";

interface IProps {
  timer: any;
  loading: boolean;
}

const Timer: FC<IProps> = ({ timer, loading }) => {
  return (
    <Stack spacing={2} direction="row" style={{ position: "relative" }}>
      <CircularProgress variant="determinate" value={loading ? 0 : timer} />
    </Stack>
  );
};

export default Timer;
